import {
  CREATE_BANNER_REQUEST,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_FAIL,
  GET_BANNERS_REQUEST,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  DELETE_BANNER_REQUEST,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_FAIL,
} from "../actionTypes";

const initialState = {
  banners: [],
  loading: false,
  error: null,
  count: 0,
  creating: false,
  createError: null,
  deleting: false,
  deleteError: null,
};

export const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BANNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        banners: action.payload.banners || [],
        count: action.payload.count || 0,
        error: null,
      };
    case GET_BANNERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        banners: [],
        count: 0,
      };
    case CREATE_BANNER_REQUEST:
      return {
        ...state,
        creating: true,
        createError: null,
      };
    case CREATE_BANNER_SUCCESS:
      return {
        ...state,
        creating: false,
        createError: null,
        banners: [action.payload.banner, ...state.banners],
        count: state.count + 1,
      };
    case CREATE_BANNER_FAIL:
      return {
        ...state,
        creating: false,
        createError: action.payload,
      };
    case DELETE_BANNER_REQUEST:
      return {
        ...state,
        deleting: true,
        deleteError: null,
      };
    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleteError: null,
        banners: state.banners.filter(banner => banner.id !== action.payload.bannerId),
        count: Math.max(0, state.count - 1),
      };
    case DELETE_BANNER_FAIL:
      return {
        ...state,
        deleting: false,
        deleteError: action.payload,
      };
    default:
      return state;
  }
};

export default bannerReducer;

